import { createStandardAction } from 'typesafe-actions';
import { MarketNews } from '@tradingblock/types';
import { NewsFeedActions } from './NewsFeedActions';

export const NEWS_UPDATERECEIVED = `@news/updated`;
export const NEWS_RECEIVED = `@news/received`;
const receivedNewsUpdate = createStandardAction(NEWS_UPDATERECEIVED)<{ news: MarketNews }>();
const receiveNews = createStandardAction(NEWS_RECEIVED)<{ news: MarketNews }>();

export const NewsActions = {
  ...NewsFeedActions,
  receivedNewsUpdate: receivedNewsUpdate,
  receiveNews: receiveNews,
};
